export default "__VITE_ASSET__CzHlGa2A__"